import {Column} from "./@types";

const hardWidth = (width: number) => ({
    width,
    maxWidth: width,
    minWidth: width
})

const editWidth = 64;

export const getCellStyle = (
    {
        name,
        grow,
        sticky
    }: Column,
    offset: number,
    width?: number,
    hardWidthDisabled = false,
) => {
    const widthStyle = grow
        ? hardWidthDisabled
            ? {width: '100%'}
            : {width: '100%', minWidth: '25vw'}
        : name === 'edit'
            ? hardWidth(editWidth)
            : isNaN(width) || !sticky || hardWidthDisabled
                ? null
                : hardWidth(width)
    ;
    const left = sticky ? offset : void (0);
    const cellStyle = {
        left,
        ...widthStyle
    }
    return cellStyle;
};
